/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Services\Pricing\PricingService.ts
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Wednesday August 14th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday August 14th 2024 3:37:30 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import Config from "Config/Config";
import { buildAxiosHeader } from "Utils/Request.utils";
import Axios from "axios";

class PricingService {
    static getPricing(id: string) {
        const url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.PRINCING}/${id}`;
        return Axios.get(url, buildAxiosHeader());
    };
}

export default PricingService;
